import { Component, ENVIRONMENT_INITIALIZER, HostListener, Inject, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_BROADCAST_CONFIG, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionRequiredAuthError, InteractionStatus,PerformanceEvent } from '@azure/msal-browser';
import { delay, filter, take, takeUntil } from 'rxjs/operators';
import { AppError } from '../common/class/app-error';
import { ExternalTokenModel } from '../Model/ExternalTokenModel';
import { IExternalTokenResponseDetails, ResultContent } from '../Model/ExternalTokenRespone';
import { TokenModel } from '../Model/TokenModel';
import { RpostAuthenticationService } from '../service/rpost-authentication.service';
import { DataSharingService } from '../service/data-sharing.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AzureTokenResponseModel } from '../Model/AzureTokenResponseModel';
import { RefreshTokenResponseModel } from '../Model/RefreshTokenResponseModel';
import { AzureIdTokenResponseModel } from '../Model/AzureIdTokenResponseModel';
import { ErrorReason } from '../Model/ErrorReasonModel';
import { environment } from 'src/environments/environment';
import { AzureTokenResponseService } from '../service/azure-token-response.service';
import { AzureAccessTokenResponseModel } from '../Model/AzureAccessTokenResponseModel';
import { AzureIdTokenClaimsResponseModel } from '../Model/AzureIdTokenClaimsResponseModel';
import { firstValueFrom, Observable, Subject, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { error, param } from 'jquery';
import { MSALInstanceFactory, MSALInterceptorConfigFactory } from '../app.module';
import { GoogleAuthenticationService } from '../service/google-authentication.service';
import { GoogleLoginProvider, SocialAuthService, SocialUser } from "@abacritt/angularx-social-login";
import { GoogleTokenResponseModel } from '../Model/Google/GoogleAccountDetailsModel';
import { UserSessionService } from '../common/user-session.service';
import { TranslationLoaderService } from '../common/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonUtilService } from '../service/common-util.service';


declare var $: any;
@Component({
  selector: 'app-rpost-authentication',
  templateUrl: './rpost-authentication.component.html',
  styleUrls: ['./rpost-authentication.component.css'],
  providers: [DataSharingService]
})
export class RPostAuthenticationComponent implements OnInit {
  title = 'RPostAuthUI';
  private readonly _destroying$ = new Subject<void>();
  isIframe = false;
  loginDisplay = false;
  providerAccessToken = '';
  refreshTokenFromRCAPAPI = '';
  accessTokenFromRCAPAPI = '';
  azureTokenResponseGv = '';
  public resultContentObj = new ResultContent();
  safeSrc: SafeResourceUrl;
  clientAppLoginUrl = '';
  callBackUrlFromQueryString = '';
  clientIdFromQueryString = '';
  loginUrlFromQueryString = '';
  isUnAuthorized = '';
  showLoginPopup = '';
  googleRefreshToken = '';
  googleSSOClientId = environment.googleSSOClientId;
  langQS = '';
  appLang: any;
  currentLoggedInUserEmail: any;
  loginFailureCounter:number=0;
  private loginInProgress = false;
  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
    , private rpostAuthService: RpostAuthenticationService
    , private authService: MsalService
    , private msalBroadcastService: MsalBroadcastService
    , private dataShareService: DataSharingService
    , private auzureTokenRespService: AzureTokenResponseService
    , private sanitizer: DomSanitizer
    , private route: ActivatedRoute
    , private googleAutheService: GoogleAuthenticationService
    , private socialAuthService: SocialAuthService
    , private user: UserSessionService
    , private langLoaderSvc: TranslationLoaderService
    , private langSvc: TranslateService
    , private commonUtilSvc: CommonUtilService) {
    let clientId = localStorage.getItem("clienIdLS")!;
    let callbackUrl = localStorage.getItem("callbackUrl_" + clientId)!;
    this.clientAppLoginUrl = localStorage.getItem("loginUrl_" + clientId)!;
    this.LogError("Log.constructor", "clientAppLoginUrl from local storage :" + this.clientAppLoginUrl, clientId);
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(callbackUrl);
    //this.route.params.subscribe( params => this.clientAppLoginUrl=params['LoginUrl']);
    this.route.queryParams.subscribe(params => {
      this.callBackUrlFromQueryString = params['CallBackUrl'];
      this.clientIdFromQueryString = params['RpostClientId'];
      this.loginUrlFromQueryString = params['LoginUrl'];
      this.LogError("Log.this.route.queryParams.subscribe", "loginUrlFromQueryString :" + this.loginUrlFromQueryString, this.clientIdFromQueryString);
      this.isUnAuthorized = params['IsUnAuthorized'];
      this.showLoginPopup = params['ShowLoginPopup'];
      this.clientAppLoginUrl = (this.clientAppLoginUrl == null && this.loginUrlFromQueryString != null)
        ? this.loginUrlFromQueryString : this.clientAppLoginUrl;
      this.LogError("Log.this.route.queryParams.subscribe", "clientAppLoginUrl :" + this.clientAppLoginUrl, this.clientIdFromQueryString);
      clientId = (clientId == null && this.clientIdFromQueryString != null) ? this.clientIdFromQueryString : clientId;
      if(params['LN']!=null && params['LN']!= undefined && params['LN'].length>0) //check if request url has params['LN'] multiple times
      {
          if(params['LN'].toString().indexOf(',')!=-1)  //check if request url has params['LN'] multiple times means (ex: en-us,en-us,en-us), then split by comma and get 1st value
            this.langQS= params['LN'].toString().split(',')[0]; 
          else
            this.langQS = params['LN'].toString();
      }
      else
          this.langQS='en-us'; //default lang
      
    });

  }

  InitLang() {
    const lang = this.user.getAppLanguage();
    const browserLang = navigator.language.toLowerCase();
    if (lang === browserLang) {
      this.langLoaderSvc.use(lang);
      this.appLang = lang;
    } else {
      this.langLoaderSvc.use(lang);
      this.appLang = browserLang;
    }
  }
  disableGoogleButton(callbackUrl: string) {
    if (callbackUrl != null && callbackUrl.indexOf("rmail.") != -1)
      $("#pnlGoogleBtn").addClass("disabledbutton");

  }
  displaySpinner() {

    $('#pnlSpinner').css("display", "block");
  }

  hideSpinner() {
    $('#pnlSpinner').css("display", "none");
  }
  displaySSOButtons() {
    //alert('display')
    $('#pnlSSOButtons').css("display", "block");
  }
  hideSSOButtons() {
    //alert('hide');
    //$('#pnlSSOButtons').css("display","none");
    $('#pnlSSOButtons').attr('style', 'display: none !important');
  }
  /* postMessageIfUserAlreadyLoggedin(clientId:string,callbackUrl:string)
  {
   
   postMessageToClientApp(clientId,callbackUrl,azuretokenResp);
  } */

  googleBtnOnMouseOver() {
    alert('hi');
    $("#googleBtn").attr('title', 'Sign in with Google');
    //document.getElementById('googleBtn')?.setAttribute('title', 'Sign in with Google');
  }

  logRequestUrlAllQueryStringValues() {
    var currentReqUrl = window.location.href;
    this.LogError("Log.ngOnInit.logRequestUrlAllQueryStringValues", "Current Request Url: " + currentReqUrl + " ", this.clientIdFromQueryString);
    const urlString = window.location.search; // Get the query string part of the URL
    const searchParams = new URLSearchParams(urlString);

    // Loop using forEach
    searchParams.forEach((value, key) => {
      console.log(`Key: ${key}, Value: ${value}`);
      this.LogError("Log.ngOnInit.logRequestUrlAllQueryStringValues", "key:" + key + " " + "value:" + value, this.clientIdFromQueryString);
    });


  }

  getLoginUrlFragment(): string {
    let loginUrl: any = this.loginUrlFromQueryString;
    var currentReqUrl = window.location.href;
    const urlString = window.location.search; // Get the query string part of the URL
    const searchParams = new URLSearchParams(urlString);

    let loginUrlFragment = '';
    let i: number = 0;
    // Loop using forEach
    searchParams.forEach((value, key) => {
      if (key.toLowerCase() != "RpostClientId".toLowerCase()
        && key.toLowerCase() != "CallBackUrl".toLowerCase()
        && key.toLowerCase() != "LoginUrl".toLowerCase()
        && key.toLowerCase() != "ShowLoginPopup".toLowerCase()
        && key.toLowerCase() != "errorReason".toLowerCase()
      ) {
        if (i == 0)
          loginUrlFragment += key + "=" + value;
        else
          loginUrlFragment += "&" + key + "=" + value;

        i++;
      }

    });

    return loginUrlFragment;
  }
  ngOnInit(): void {

    this.logRequestUrlAllQueryStringValues();

    if (this.langQS != null && this.langQS != '')
      this.appLang = this.langQS;
    else
      this.appLang = 'en-us';
    this.langSvc.setDefaultLang(this.appLang);
    localStorage.setItem('appLang', this.appLang);
    this.InitLang();
    $('#divProcessingCommon').css("display", "none");
    //this.disableGoogleButton(this.callBackUrlFromQueryString); //this is temp fix only
    this.displaySSOButtons();
    this.getGoogleTokenResponseAndRedirectToClientApplication();
    this.addHandleRedirectPromise();
    this.addMsalEventListeners();
    const enableAddPerformanceLogging: boolean = environment.enableAddPerformanceLogging;
    if(enableAddPerformanceLogging)
        this.addPerformanceLogging();
    //We commented for below code related to this ticket  RS-2143
    /* let isPopupblocker=this.detectPopupBlocker();
    if(isPopupblocker)
    {
      this.hideSSOButtons();
    }
    else
    {
      this.displaySSOButtons();
    } */
  }

  detectPopupBlocker()
    {
    
    var isPopupblocker=false;
    var windowUrl = 'about:blank';
    var windowId = 'TestPopup_' + new Date().getTime();
    var windowFeatures = 'width=1,height=1,left=10000,top=10000';
    //var windowFeatures = 'left=0%,top=0%,width=0.1%,height=0.1%';
    var windowRef = window.open(windowUrl, windowId, windowFeatures);

    if ( !windowRef )
    {
      //alert('A popup blocker was detected. Please turn it off to use this application.');
      //return false;
      $('#pnlPopupblockerMsg').css("display","block");
      isPopupblocker=true;
    }
    else
    {
      // No popup blocker was detected...
      windowRef.close();
      isPopupblocker=false;
      $('#pnlPopupblockerMsg').css("display","none");
      //document.getElementById('pageContent').style.display = 'block';
    }

    return isPopupblocker;
    }
  private addPerformanceLogging(): void {
      this.authService.instance.addPerformanceCallback((events: PerformanceEvent[]) => {
        events.forEach((event) => {
          console.log("[MSAL-PERF] Event: " + event.name);
          console.log("Event authority: " + event.authority);
          console.log("Duration: "+ event.durationMs?.toFixed(2) + " ms");
          console.log("CorrelationId: " + event.correlationId);

          this.LogError("Log.addPerformanceCallback", "User Account: " + this.currentLoggedInUserEmail + 
                         " Event:" + event.name + 
                         " Authority:" + event.authority + 
                         " Duration: "+ event.durationMs?.toFixed(2) + " ms" +
                         " CorrelationId: " + event.correlationId 
            , this.clientIdFromQueryString)
        });
      });
  }

  private addHandleRedirectPromise() : void{
    this.authService.instance.initialize()
    .then(() => {
          this.authService.instance.handleRedirectPromise()
          .then((response) => {
            if (response && response.account) {
                this.authService.instance.setActiveAccount(response.account);
            }
            this.currentLoggedInUserEmail = this.authService.instance.getActiveAccount();
            console.log('Initial Account:', this.currentLoggedInUserEmail);
            this.LogError("Log.addHandleRedirectPromise.handleRedirectPromise", "User Account: " + this.currentLoggedInUserEmail, this.clientIdFromQueryString)
          })
            .catch((error: string) => {
              console.error('Error handling redirect promise:', error);
                let errorMessage = "N/A";
                if (error && typeof error === "object") {
                  errorMessage = this.convertObjToJsonString(error);
                } else {
                  // If error is not an object, convert it to a string
                  errorMessage = String(error);
                }
                this.LogError("Log.addHandleRedirectPromise.handleRedirectPromise.Error", errorMessage, this.clientIdFromQueryString)
            });
          })
    .catch(error => {
      console.error("MSAL Initialization failed", error);
      let errorMessage = "N/A";
      if (error && typeof error === "object") {
        errorMessage = this.convertObjToJsonString(error);
      } else {
        // If error is not an object, convert it to a string
        errorMessage = String(error);
      }
      this.LogError("Log.addHandleRedirectPromise.initialize.Catch", errorMessage, this.clientIdFromQueryString)
    });
  }

//Region Microsoft login popup code
//Code addded for login success, login failure , inprogress event types to call in ngOnInit method
  private addMsalEventListeners(): void {

  // Temporary debug logging
  this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) =>
          msg.eventType !== EventType.LOGIN_SUCCESS &&
          msg.eventType !== EventType.LOGIN_FAILURE && 
          msg.eventType !== EventType.ACQUIRE_TOKEN_FAILURE 
        ),
        takeUntil(this._destroying$) 
      )
      .subscribe((msg: EventMessage) => {
        console.log("MSAL Event :", msg.eventType, msg);
        this.LogError("Log.addMsalEventListeners.Generic", "Event: " + msg.eventType, this.clientIdFromQueryString);
      });
    
  this.msalBroadcastService.msalSubject$
      .pipe(filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS))
      .subscribe((msg: EventMessage) => {
        const payload = msg.payload as AuthenticationResult;
        this.authService.instance.setActiveAccount(payload.account);
        
        const loginAccount = payload.account;
        this.currentLoggedInUserEmail = loginAccount?.username;
        this.LogError("Log.addMsalEventListeners.Login_Success", "User Account: " + loginAccount?.username + " " + this.convertObjToJsonString(msg), this.clientIdFromQueryString);
        /* this.LogError("Log.addMsalEventListeners.AuthenticationResult", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);
        this.authService.instance.setActiveAccount(payload.account);
        this.LogError("Log.addMsalEventListeners.Response", this.convertObjToJsonString(payload) + "User Account: " + loginAccount?.username, this.clientIdFromQueryString);

        let azureTokenRespObj = this.getAzureTokenResponseObject(payload);
        let azuretokenresp = this.getAzureTokenJsonResponseAsString(azureTokenRespObj);
        // localStorage.setItem("azureTokenRespLocalStorage",azuretokenresp);
        if (azuretokenresp != null && azuretokenresp != undefined && azuretokenresp.length > 0) {
          localStorage.setItem("azureTokenRespLocalStorage", azuretokenresp);
          this.LogError("Log.addMsalEventListeners.EventType.LOGIN_SUCCESS", "RedirectToClient. User Account: " + loginAccount?.username, this.clientIdFromQueryString);
          this.redirectToClientApplication(azuretokenresp);
        }
        else //LOGIN_SUCCESS fallback scenario
        {
          let errorReason = ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_FIRST_TIME_LOGIN; //"Azure token response is empty for First time azure login";
          this.LogError("Log.addMsalEventListeners.EventType.LOGIN_SUCCESS.Else", "RedirectToClient.WithError.User Account: " + loginAccount?.username, this.clientIdFromQueryString);          
          //this.redirectToClientAppLoginWhenErrorOccured(errorReason);
          this.loginPopupPromptForUserNamAndPwd();
          //this.invokeAcquireTokenSilent();
        }
        console.log("addMsalEventListeners.LOGIN_SUCCESS", payload.account?.username); */
      },
      error => {
        var errorDesc = error.toString();
        let errorReason = '';
        this.displayActualErrorInConsole(errorDesc, "addMsalEventListeners.LOGIN_SUCCESS");
        if (typeof errorDesc == "string" && errorDesc.indexOf(ErrorReason.CONSENT_REQUIRED) > -1) {
          errorReason = ErrorReason.CONSENT_REQUIRED;
          this.redirectToClientAppLoginWhenErrorOccured(errorReason);
        }
        else {
          errorReason = ErrorReason.UNKNOWN_ERROR_OCCURED;
          this.redirectToClientAppLoginWhenErrorOccured(errorReason);
        }
      }
    );
   
    this.msalBroadcastService.msalSubject$
    .pipe(
      filter((msg: EventMessage) => 
        msg.eventType === EventType.LOGIN_FAILURE || 
        msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE
      ),
      takeUntil(this._destroying$)
    )
    .subscribe((msg: EventMessage) => {
      console.error('MSAL INSIDE LOGIN_FAILURE:', msg);  
      const activeAccount = this.authService.instance.getActiveAccount();
      
      if (!activeAccount) {

        // This is a real failure: no user is logged in
        const errorJson = JSON.stringify(msg, Object.getOwnPropertyNames(msg));
        const errorObjJson = JSON.stringify(msg?.error);
        const errorJsonText= eventMessageToJsonString(msg);
        console.error('MSAL INSIDE LOGIN_FAILURE No ActiveAccount found:', msg);  
        this.LogError("Log.addMsalEventListeners.Login_Failure", "User Account: null. Error Json: " + errorJsonText, this.clientIdFromQueryString);
        this.LogError("Log.addMsalEventListeners.Login_Failure", "User Account: null. Error: " + errorObjJson, this.clientIdFromQueryString);
      }
      else {
        console.error('MSAL INSIDE LOGIN_FAILURE ActiveAccount found:', msg);  
        // Ignore because login was ultimately successful
        this.LogError("Log.addMsalEventListeners.Ignored_Login_Failure", "Active account exists. Ignoring LOGIN_FAILURE.", this.clientIdFromQueryString);
      }
        /* if (msg.error?.message.includes('50140')) {
          console.warn('KMSI interrupt detected (50140). Retrying login...');
          this.LogError("Log.addMsalEventListeners.LOGIN_FAILURE", "User Account: " + this.currentLoggedInUserEmail + " " + msg.error?.message, this.clientIdFromQueryString);
        }

        if (localStorage.getItem("IsPopupClosedFromRCAP") == null) {
          let errorReason = ErrorReason.AZURE_LOGIN_FAILURE;
          this.LogError("Log.addMsalEventListeners.LOGIN_FAILURE", "User Account: " + this.currentLoggedInUserEmail + " " + errorReason, this.clientIdFromQueryString);
          this.redirectToClientAppLoginWhenErrorOccured(errorReason);
        }
        else if (localStorage.getItem("IsPopupClosedFromRCAP") != null
                && localStorage.getItem("IsPopupClosedFromRCAP") == 'Y') {
          localStorage.removeItem("IsPopupClosedFromRCAP");
          let azuretokenresp = null;
          if (localStorage.getItem("azureTokenRespLocalStorage") != null)
            azuretokenresp = localStorage.getItem("azureTokenRespLocalStorage");
          if (azuretokenresp != null && azuretokenresp != undefined && azuretokenresp.length > 0)
          {
            this.LogError("Log.addMsalEventListeners.EventType.LOGIN_FAILURE.StorageNotEmpty", "User Account: " + this.currentLoggedInUserEmail + " " +  "Azure token response is available", this.clientIdFromQueryString)
            this.redirectToClientApplication(azuretokenresp);
          }
          else {
            let errorReason = ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_FIRST_TIME_LOGIN;//"Azure token response is empty for First time azure login";
            this.LogError("Log.addMsalEventListeners.EventType.LOGIN_FAILURE.StorageEmpty", "User Account: " + this.currentLoggedInUserEmail + " " + errorReason , this.clientIdFromQueryString)
            //this.redirectToClientAppLoginWhenErrorOccured(errorReason);
            this.loginPopupPromptForUserNamAndPwd();
            //this.invokeAcquireTokenSilent();
            
          }
        }
        console.error("addMsalEventListeners.LOGIN_FAILURE", msg.error?.message); */
        
      });

      /* this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACCOUNT_ADDED ||
            msg.eventType === EventType.ACCOUNT_REMOVED
        )
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          // window.location.pathname = '/';
          console.log("this.msalBroadcastService.msalSubject$.getAllAccounts().length value is 0")
          window.location.href=this.clientAppLoginUrl;
        } else {
          this.setLoginDisplay();
        }
      }); */
    this.msalBroadcastService.inProgress$
      .pipe(filter((status: InteractionStatus) => status === InteractionStatus.None)
            ,takeUntil(this._destroying$)
            )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      });

      this.msalBroadcastService.inProgress$.subscribe(status => {
        this.loginInProgress = (status === InteractionStatus.Login);
      });
    }

    invokeAcquireTokenSilent()
    {
        let scopeId = environment.scopeId;
        var username = this.currentLoggedInUserEmail;
        this.LogError("Log.invokeAcquireTokenSilent", "User Account: " + this.currentLoggedInUserEmail , this.clientIdFromQueryString);
        //this.checkAndSetActiveAccount();
        //let activeAccount=this.authService.instance.getActiveAccount();
        const activeAccount = this.authService.instance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
        const accounts = this.authService.instance.getAllAccounts();
    
        if (!activeAccount && accounts.length === 0) {
            /*
            * User is not signed in. Throw error or wait for user to login.
            * Do not attempt to log a user in outside of the context of MsalProvider
            */   
            this.LogError("Log.invokeAcquireTokenSilent", "NoActiveAccount: " + this.convertObjToJsonString(activeAccount) , this.clientIdFromQueryString);
        }
        this.LogError("Log.invokeAcquireTokenSilent", "activeAccount: " + this.convertObjToJsonString(activeAccount) , this.clientIdFromQueryString);
        var currentAccount: any = this.authService.instance.getAccountByUsername(this.currentLoggedInUserEmail);
        this.LogError("Log.invokeAcquireTokenSilent", "currentAccount: " + this.convertObjToJsonString(currentAccount) , this.clientIdFromQueryString);
        var request = {
          scopes: ["api://" + scopeId + "/.default"],
          account: activeAccount || accounts[0],
          forceRefresh: true,
          refreshTokenExpirationOffsetSeconds: 7200 // 2 hours * 60 minutes * 60 seconds = 7200 seconds
        };
        
        this.acquireTokenSilentImpl(request);

    }
//End region Microsoft login popup code
  generateIframeHtmlElement() {
    this.hidePnlComingSoon();
    let clientId = this.getRpostClientId();

    let callbackUrl = this.getCallBackUrl();
    this.clearLocalStorageTokenResponse();
    this.generateDataShareIframeHtmlElement(callbackUrl, clientId);
  }



  //#region  GoogleSociallogin functionality



  getGoogleTokenResponseAndRedirectToClientApplication() {
    this.generateIframeHtmlElement();
    this.getGoogleAccountDetails();

  }

  getGoogleAccountDetails() {
    let userDetails: any;
    this.socialAuthService.authState.subscribe((user) => {
      //this.user = user;
      userDetails = user;
      console.log(userDetails);
      if (userDetails != null) {
        let googleTokenResponseModelObj = this.prepareGoogleTokenResponseObject(userDetails);
        let googleTokenResponse = this.getGoogleTokenResponse(googleTokenResponseModelObj);
        if (googleTokenResponse != null && googleTokenResponse != '') {
          this.redirectToClientApplication(googleTokenResponse);
          //this.googleAutheService.getAccessToken();
          //alert(this.googleAutheService.refreshToken());
        }
      }
      //alert(this.user.authToken);
      //alert(userDetails.email);
      //this.loggedIn = (user != null);
    },
      error => {
        let errorDesc = error;
        this.displayActualErrorInConsole(errorDesc, "getGoogleAccountDetails.Error");
        this.redirectToClientAppLoginWhenErrorOccured(ErrorReason.GOOGLE_LOGIN_FAILED);
      }
    );

    //return userDetails;
  }

  getGoogleTokenResponse(googleTokenRespDetails: GoogleTokenResponseModel) {
    //todo: to be implemented as similar to azure token response
    return this.convertObjToJsonString(googleTokenRespDetails);

  }

  convertObjToJsonString(obj: any) {
    let response;
    response = JSON.stringify(obj);
    return response;
  }

  getGoogleRefreshToken() {
    /* return this.socialAuthService.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID)
    .then(refreshToken => this.googleRefreshToken = refreshToken);
 */
  }

  prepareGoogleTokenResponseObject(userDetails: SocialUser) {
    let googleTokenRespObj = new GoogleTokenResponseModel();
    googleTokenRespObj.accesstoken = userDetails.idToken;
    googleTokenRespObj.idtoken = userDetails.idToken;
    googleTokenRespObj.refreshtoken = ''; // this.getGoogleRefreshToken();
    googleTokenRespObj.useremail = userDetails.email;
    googleTokenRespObj.username = userDetails.name;
    googleTokenRespObj.ssotype = environment.googleProvider;
    return googleTokenRespObj;
  }


  //#endregion

  CancelCurrentRequest() {
    window.location.href = this.loginUrlFromQueryString; //+'?errorReason='+ErrorReason.USER_CANCELLED_CURRENT_REQUEST;

  }


  AcquireTokenSilentAndRedirectClientAppIfAlreadyLogggedIn() {
    this.LogError("Log.acquireTokenSilent.AuthenticationResult.Begining", "User Account: " + this.currentLoggedInUserEmail, this.clientIdFromQueryString);
    // if(this.isUserAlreadyLoggedin())
    // {
    //alert('You have already logged in using Azure Sign in');
    this.hideSSOButtons();
    let clientId = this.getRpostClientId();

    let callbackUrl = this.getCallBackUrl();
    //this.clearLocalStorageTokenResponse();
    console.log("Before iframe creation");
    this.generateDataShareIframeHtmlElement(callbackUrl, clientId);
    this.checkAndSetActiveAccount();
    console.log("After iframe creation");
    let scopeId = environment.scopeId;
    var username = this.currentLoggedInUserEmail;
    var currentAccount: any = this.authService.instance.getAccountByUsername(username);
    //acquire token sliently article
    //https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/4b74fda49768168768ed427609941566e41456d3/lib/msal-browser/docs/token-lifetimes.md#token-renewal
    //user already loggin scenario
    //alert('already logged in');
    var request = {
      scopes: ["api://" + scopeId + "/.default"],
      account: currentAccount,
      forceRefresh: true,
      refreshTokenExpirationOffsetSeconds: 7200 // 2 hours * 60 minutes * 60 seconds = 7200 seconds
    };

    this.authService.acquireTokenSilent(request)
      .subscribe((result: AuthenticationResult) => {
        console.log(result);
        const payload = result as AuthenticationResult;
        const loginAccount = payload.account;
        this.authService.instance.setActiveAccount(payload.account);
        this.currentLoggedInUserEmail = loginAccount?.username;
        this.LogError("Log.acquireTokenSilent.AuthenticationResult", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);
        let azureTokenRespObj = this.getAzureTokenResponseObjectForAquireTokenSilent(payload);//this.getAzureTokenResponseObject(payload);
        let azuretokenresp = this.getAzureTokenJsonResponseAsString(azureTokenRespObj);
        //this.azureTokenResponseGv=azuretokenresp;
        if (azuretokenresp != null && azuretokenresp != "")
          this.redirectToClientApplication(azuretokenresp);
        else {
          let errorReason = ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_ACQUIRE_TOKEN_SILENT; //"Azure token response is empty for acquireTokenSilent Method";
          this.LogError("Log.acquireTokenSilent.AuthenticationResult.AzureTokenRespEmpty", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);
          this.redirectToClientAppLoginWhenErrorOccured(errorReason);
        }


      }
        ,
        error => {
          let errorDesc = error;
          this.displayActualErrorInConsole(errorDesc, "acquireTokenSilent.Request.Error");
          var customError = ErrorReason.AZURE_TOKEN_ACQUIRE_SILENT_FAILED;
          this.redirectToClientAppLoginWhenErrorOccured(customError);
          //AcquireTokenSilent Failure, send an interactive request.
          //alert('eeror')
          //  this.authService.acquireTokenPopup(request)
          //                     .subscribe((result: AuthenticationResult) => {
          //     console.log(result);
          //     const payload = result as AuthenticationResult;
          //     const loginAccount = payload.account;
          //     this.currentLoggedInUserEmail=loginAccount?.username;
          //     this.LogError("Log.acquireTokenPopup.AuthenticationResult","User Account: "+loginAccount?.username,this.clientIdFromQueryString);
          //     this.authService.instance.setActiveAccount(payload.account);

          //     let azureTokenRespObj= this.getAzureTokenResponseObjectForAquireTokenSilent(payload);//this.getAzureTokenResponseObject(payload);
          //     let azuretokenresp= this.getAzureTokenJsonResponse(azureTokenRespObj);
          //     //this.azureTokenResponseGv=azuretokenresp;
          //     if(azuretokenresp!=null && azuretokenresp!="")
          //         this.redirectToClientApplication(azuretokenresp);
          //     else
          //     {
          //       let errorReason= ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_ACQUIRE_TOKEN_POPUP; //"Azure token response is empty from acquireTokenPopup method";
          //       this.LogError("Log.acquireTokenPopup.AuthenticationResult.AzureTokenRespEmpty","User Account: "+loginAccount?.username,this.clientIdFromQueryString);
          //       this.redirectToClientAppLoginWhenErrorOccured(errorReason);
          //     }
          //     //this.redirectToClientApplication();


          // }
          // ,
          // error => {

          //     let errorDesc=error;
          //     this.displayActualErrorInConsole(errorDesc,"acquireTokenPopup.Request.Error");
          //     let errorReason= ErrorReason.ACQUIRE_TOKEN_POPUP_FAILURE;
          //     this.redirectToClientAppLoginWhenErrorOccured(errorReason);

          // },


          // );


        }/* ,
            () => {
              // 'onCompleted' callback.
              // No errors, route to new page here
            } */

      );

    this.msalBroadcastService.msalSubject$
      .pipe(
        //filter((msg: EventMessage) => msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE),
        filter((msg: EventMessage) => msg.eventType.toString().includes("FAILURE")),
        takeUntil(this._destroying$)
      )
      .subscribe((result: EventMessage) => {

        /* start capture Error Logs*/
        // Extract error details
        const error = result.error;
        console.error('msalBroadcastService.msalSubject Error object: ', error);
        let errorMessage = "N/A";
        if (error && typeof error === "object") {
          errorMessage = this.convertObjToJsonString(error);
        } else {
          // If error is not an object, convert it to a string
          errorMessage = String(error);
        }
        let userEmail = this.currentLoggedInUserEmail;
        this.LogError("Log.msalBroadcastService.Failure", "User Account : " + userEmail + " Failure event:" + result.eventType +
          " Error:" + errorMessage,
          this.clientIdFromQueryString);
        // Attempt to capture account details; some failures there might be no account.
        if (this.authService.instance.getAllAccounts().length > 0) {
          let accounts = this.authService.instance.getAllAccounts();
          const account = accounts[0];
          if (account) {
            this.currentLoggedInUserEmail = account.username;
            this.LogError("Log.msalBroadcastService.msalSubject", "User Account: " + account.username, this.clientIdFromQueryString);
          } else {
            console.error("No user account information available.");
            this.LogError("Log.msalBroadcastService.msalSubject", "No user account information available.", this.clientIdFromQueryString);
          }
        }
        /* end capture Error Logs*/

        let errorReason = "ACQUIRE_TOKEN_FAILURE";
        if (result.eventType === EventType.ACQUIRE_TOKEN_FAILURE)
          this.loginPopup();
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      })



    // }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
  
  async AzureSignIn() {
    
    this.generateIframeHtmlElement();
    
    if (!this.isUserAlreadyLoggedin()) {
      console.log("first time login");
      this.LogError("Log.AzureSignIn", "first time login", this.clientIdFromQueryString);
      await this.firstTimeLoginAndDisplayLoginPopup();

    }
    else if (this.isUserAlreadyLoggedin() &&
      (this.isUnAuthorized != null && this.isUnAuthorized == 'Y')
      || (this.showLoginPopup != null && this.showLoginPopup == 'Y')
    ) {
      console.log('Already logged in, unauthorized request/unable to login due to some reason case, show loginpopup');
      this.LogError("Log.AzureSignIn", "Already logged in.Unauthorized request/unable to login due to some reason case,show loginpopup", this.clientIdFromQueryString);
      //this.promptForPasswordForUnAuthroizedRequest();
      this.chooseAccountToLoginForAlreadyLoggedIn(true);
    }
    else if (this.isUserAlreadyLoggedin()) {
      console.log("AlreadyLoggedIn");
      this.LogError("Log.AzureSignIn", "AlreadyLoggedIn", this.clientIdFromQueryString);

      this.chooseAccountToLoginForAlreadyLoggedIn(false);
    }
  }

  async firstTimeLoginAndDisplayLoginPopup() {
    
    this.LogError("Log.firstTimeLoginAndDisplayLoginPopup", "Begining of the method", this.clientIdFromQueryString);
    try {
      this.hideSSOButtons();
      const response = await this.loginPopup();
      this.LogError("Log.firstTimeLoginAndDisplayLoginPopup.AfterLoginPopupCall", "User Account:" +  this.currentLoggedInUserEmail, this.clientIdFromQueryString);
  
      if (!response || !response.account || !response.idToken) {
        throw new Error("Login result is empty or invalid.");
      }

      const loginAccount = response.account;
      this.currentLoggedInUserEmail = loginAccount?.username;
      this.authService.instance.setActiveAccount(response.account); 
      this.LogError("Log.firstTimeLoginAndDisplayLoginPopup.Login_Success", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);

      let azureTokenRespObj = this.getAzureTokenResponseObject(response);
      let azuretokenresp = this.getAzureTokenJsonResponseAsString(azureTokenRespObj);
      if (azuretokenresp != null && azuretokenresp != undefined && azuretokenresp.length > 0) {
        localStorage.setItem("azureTokenRespLocalStorage", azuretokenresp);
        this.LogError("Log.firstTimeLoginAndDisplayLoginPopup.Login_Success.Redirect", "User Account: " + loginAccount?.username + " Redirect To Client", this.clientIdFromQueryString);
        this.redirectToClientApplication(azuretokenresp); // This posts the message.
      }
      else //LOGIN_SUCCESS fallback scenario
      {
        let errorReason = ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_FIRST_TIME_LOGIN; //"Azure token response is empty for First time azure login";
        this.LogError("Log.firstTimeLoginAndDisplayLoginPopup.LOGIN_SUCCESS.Else", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);          
        this.redirectToClientAppLoginWhenErrorOccured(errorReason);
      }
  
    } catch (error: any) {
      const errorMsg = error?.error?.message || error?.message || error.toString();
      this.displayActualErrorInConsole(errorMsg, "firstTimeLoginAndDisplayLoginPopup.catch");
      this.LogError("Log.firstTimeLoginAndDisplayLoginPopup.Catch", "Error: " + errorMsg, this.clientIdFromQueryString);

      if (localStorage.getItem("IsPopupClosedFromRCAP") != null  && localStorage.getItem("IsPopupClosedFromRCAP") == 'Y') {
                localStorage.removeItem("IsPopupClosedFromRCAP"); 
      }

      if (errorMsg.includes("50140")) {
        this.LogError("Log.firstTimeLoginAndDisplayLoginPopup.KMSI", "KMSI retry suggested", this.clientIdFromQueryString);
      }
      else if (typeof errorMsg == "string" && errorMsg.indexOf(ErrorReason.CONSENT_REQUIRED) > -1) {
        let errorReason = ErrorReason.CONSENT_REQUIRED;
        this.redirectToClientAppLoginWhenErrorOccured(errorReason);
      }
      const errorReason = errorMsg.includes("user_cancelled")? ErrorReason.USER_CANCELLED: ErrorReason.AZURE_LOGIN_FAILURE;
      this.redirectToClientAppLoginWhenErrorOccured(errorReason);
    }

    /* this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe((result: EventMessage) => {
        console.log(result);
        const payload = result.payload as AuthenticationResult;
        const loginAccount = payload.account;
        this.currentLoggedInUserEmail = loginAccount?.username;
        this.LogError("Log.firstTimeLoginAndDisplayLoginPopup.Result", "User Account: " + loginAccount?.username + " " + this.convertObjToJsonString(result), this.clientIdFromQueryString);
        this.LogError("Log.firstTimeLoginAndDisplayLoginPopup.AuthenticationResult", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);
        this.authService.instance.setActiveAccount(payload.account);
        this.LogError("Log.firstTimeLoginAndDisplayLoginPopup.Response", this.convertObjToJsonString(payload) + "User Account: " + loginAccount?.username, this.clientIdFromQueryString);

        let azureTokenRespObj = this.getAzureTokenResponseObject(payload);
        let azuretokenresp = this.getAzureTokenJsonResponse(azureTokenRespObj);
        // localStorage.setItem("azureTokenRespLocalStorage",azuretokenresp);
        if (azuretokenresp != null && azuretokenresp != "") {
          localStorage.setItem("azureTokenRespLocalStorage", azuretokenresp);
          this.LogError("Log.firstTimeLoginAndDisplayLoginPopup.azureTokenRespLocalStorage", "RedirectToClient. User Account: " + loginAccount?.username, this.clientIdFromQueryString);
          this.redirectToClientApplication(azuretokenresp);
        }
        else //LOGIN_SUCCESS fallback scenario
        {
          let errorReason = ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_FIRST_TIME_LOGIN; //"Azure token response is empty for First time azure login";
          this.LogError("Log.firstTimeLoginAndDisplayLoginPopup.Response", errorReason + ".Calling loginPopup. User Account: " + loginAccount?.username, this.clientIdFromQueryString);
          //this.AcquireTokenSilentAndRedirectClientAppIfAlreadyLogggedIn();
          this.redirectToClientAppLoginWhenErrorOccured(errorReason);
          //this.loginPopup();
        }
      },

        error => {
          var errorDesc = error.toString();
          let errorReason = '';
          this.displayActualErrorInConsole(errorDesc, "firstTimeLoginAndDisplayLoginPopup.Error");
          if (typeof errorDesc == "string" && errorDesc.indexOf(ErrorReason.CONSENT_REQUIRED) > -1) {
            errorReason = ErrorReason.CONSENT_REQUIRED;
            this.redirectToClientAppLoginWhenErrorOccured(errorReason);
          }
          else {
            errorReason = ErrorReason.UNKNOWN_ERROR_OCCURED;
            this.redirectToClientAppLoginWhenErrorOccured(errorReason);
          }
        }
      ); */

    /* Moved below block to ngoninit */
    /* this.authService.instance.handleRedirectPromise()
    .then((response) => {
       if (response && response.account) {
          this.authService.instance.setActiveAccount(response.account);
      }
      this.currentLoggedInUserEmail = this.authService.instance.getActiveAccount();
      console.log('Initial Account:', this.currentLoggedInUserEmail);
      this.LogError("Log.firstTimeLoginAndDisplayLoginPopup.handleRedirectPromise", "User Account: " + this.currentLoggedInUserEmail, this.clientIdFromQueryString)
    })
      .catch((error: string) => {
        console.error('Error handling redirect promise:', error);
        this.LogError("Log.firstTimeLoginAndDisplayLoginPopup.handleRedirectPromise.Error", error, this.clientIdFromQueryString)
      }); */
    
    this.LogError("Log.firstTimeLoginAndDisplayLoginPopup", "End of the method", this.clientIdFromQueryString);  
    /*this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      })
    */ // moved to ngOnInit
      
    /* this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_FAILURE),
      )
      .subscribe((result: EventMessage) => {
        console.error('MSAL Popup Login Failure:', result);
        if (result.error?.message.includes('50140')) {
          console.warn('KMSI interrupt detected (50140). Retrying login...');
          this.LogError("Log.firstTimeLoginAndDisplayLoginPopupResponse.LOGIN_FAILURE", "User Account: " + this.currentLoggedInUserEmail + " " + result.error?.message, this.clientIdFromQueryString);
          //this.login(); // Retry login

        }
        if (localStorage.getItem("IsPopupClosedFromRCAP") == null) {
          let errorReason = ErrorReason.AZURE_LOGIN_FAILURE;


          this.redirectToClientAppLoginWhenErrorOccured(errorReason);
        }
        else if (localStorage.getItem("IsPopupClosedFromRCAP") != null
          && localStorage.getItem("IsPopupClosedFromRCAP") == 'Y') {
          localStorage.removeItem("IsPopupClosedFromRCAP");
          let azuretokenresp = null;
          if (localStorage.getItem("azureTokenRespLocalStorage") != null)
            azuretokenresp = localStorage.getItem("azureTokenRespLocalStorage");
          if (azuretokenresp != null && azuretokenresp != "")
            this.redirectToClientApplication(azuretokenresp);
          else {
            let errorReason = ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_FIRST_TIME_LOGIN;//"Azure token response is empty for First time azure login";
            this.LogError("Log.firstTimeLoginAndDisplayLoginPopupResponse.StorageEmpty", "User Account: " + this.currentLoggedInUserEmail + " " + errorReason + ". Calling loginPopup", this.clientIdFromQueryString)
            this.redirectToClientAppLoginWhenErrorOccured(errorReason);
            //this.loginPopup();
            //this.AcquireTokenSilentAndRedirectClientAppIfAlreadyLogggedIn();
          }
          //window.location.href=this.callBackUrlFromQueryString;
        }

      }); */
    
  }

  chooseAccountToLoginForAlreadyLoggedIn(IsUnAuthorized: boolean) {
    this.hideSSOButtons();
    if (IsUnAuthorized) {
      console.log("already logged in, but unauthorized, autologin");
      this.LogError("Log.chooseAccountToLoginForAlreadyLoggedIn", "already logged in, but unauthorized", this.clientIdFromQueryString);
    }
    else {
      console.log("already logged in");
      this.LogError("Log.chooseAccountToLoginForAlreadyLoggedIn", "already logged in", this.clientIdFromQueryString);
    }


    let scopeId = environment.scopeId

    var request = {
      scopes: ["api://" + scopeId + "/.default"],
      prompt: 'select_account'
    };

    this.authService.loginPopup(request)
      .subscribe((result: AuthenticationResult) => {
        console.log(result);


        const payload = result as AuthenticationResult;
        const loginAccount = payload.account;
        this.currentLoggedInUserEmail = loginAccount?.username;
        this.LogError("Log.chooseAccountToLoginForAlreadyLoggedIn.loginPopup.Result", "User Account: " + loginAccount?.username + " " + this.convertObjToJsonString(result), this.clientIdFromQueryString);
        this.LogError("Log.chooseAccountToLoginForAlreadyLoggedIn.loginPopup.AuthenticationResult", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);
        this.authService.instance.setActiveAccount(payload.account);
        this.LogError("Log.chooseAccountToLoginForAlreadyLoggedIn.loginPopup.Response", this.convertObjToJsonString(payload), this.clientIdFromQueryString);
        let azureTokenRespObj = this.getAzureTokenResponseObjectForAquireTokenSilent(payload);//this.getAzureTokenResponseObject(payload);
        let azuretokenresp = this.getAzureTokenJsonResponseAsString(azureTokenRespObj);

        //this.azureTokenResponseGv=azuretokenresp;

        if (azuretokenresp != null && azuretokenresp != undefined && azuretokenresp.length>0)
        {
            this.LogError("Log.chooseAccountToLoginForAlreadyLoggedIn.loginPopup.If", "User Account: " + loginAccount?.username + " " , this.clientIdFromQueryString);
            this.redirectToClientApplication(azuretokenresp);
        }
        else {
          let errorReason = ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_ACQUIRE_TOKEN_POPUP;//"Azure token response is empty from acquireTokenPopup method";
          this.LogError("Log.chooseAccountToLoginForAlreadyLoggedIn.loginPopup.Else", "User Account: " + loginAccount?.username + " " + "ErrorReason:"+ errorReason, this.clientIdFromQueryString);
          this.redirectToClientAppLoginWhenErrorOccured(errorReason);
        }
        //this.redirectToClientApplication();
      },
        error => {

          //if(IsUnAuthorized)
          //{
          var errorDesc = error.toString();
          let errorReason = ''
          this.LogError("Log.chooseAccountToLoginForAlreadyLoggedIn.loginPopup.Error", "User Account: " + this.currentLoggedInUserEmail + this.convertObjToJsonString(errorDesc), this.clientIdFromQueryString);
          //alert(typeof errorDesc);
          if (typeof errorDesc == "string" && errorDesc.indexOf(ErrorReason.USER_CANCELLED) > -1) {
            errorReason = ErrorReason.USER_CANCELLED_FROM_UNAUTHORIZED_AT_LOGIN_POPUP;
            this.redirectToClientAppLoginWhenErrorOccured(errorReason);
            //this.acquireTokenSilientImpl(request);
          }
          else {
            this.displayActualErrorInConsole(errorDesc, "chooseAccountToLoginForAlreadyLoggedIn.loginPopup.Request.Error");
            errorReason = ErrorReason.UNKNOWN_ERROR_OCCURED;
            this.redirectToClientAppLoginWhenErrorOccured(errorReason);
          }

          //}
          /*  else
           {
             this.authService.acquireTokenSilent(request)
                                     .subscribe((result: AuthenticationResult) => {
                     //alert('acquire token silent');
                     //alert(result.accessToken);
   
                     console.log(result);
                     const payload = result as AuthenticationResult;
                     
                     this.authService.instance.setActiveAccount(payload.account);
                     
                     let azureTokenRespObj= this.getAzureTokenResponseObjectForAquireTokenSilent(payload);//this.getAzureTokenResponseObject(payload);
                     let azuretokenresp= this.getAzureTokenJsonResponse(azureTokenRespObj);
                     //this.azureTokenResponseGv=azuretokenresp;
                     if(azuretokenresp!=null && azuretokenresp!="")
                         this.redirectToClientApplication(azuretokenresp);
                     else
                     {
                       let errorReason= ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_ACQUIRE_TOKEN_SILENT; //"Azure token response is empty for acquireTokenSilent Method";
                       this.redirectToClientAppLoginWhenErrorOccured(errorReason);
                     }
                     
                     
                 }
                 ,
               error => {
                 let errorDesc=error;
                 this.displayActualErrorInConsole(errorDesc);
                  //AcquireTokenSilent Failure, send an interactive request.
                   //alert('eeror')
                  this.authService.acquireTokenPopup(request)
                                     .subscribe((result: AuthenticationResult) => {
                     //alert('acquire token silent');
                     //alert(result.accessToken);
   
                     console.log(result);
                     const payload = result as AuthenticationResult;
                     
                     this.authService.instance.setActiveAccount(payload.account);
                     
                     let azureTokenRespObj= this.getAzureTokenResponseObjectForAquireTokenSilent(payload);//this.getAzureTokenResponseObject(payload);
                     let azuretokenresp= this.getAzureTokenJsonResponse(azureTokenRespObj);
                     //this.azureTokenResponseGv=azuretokenresp;
                     if(azuretokenresp!=null && azuretokenresp!="")
                         this.redirectToClientApplication(azuretokenresp);
                     else
                     {
                       let errorReason= ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_ACQUIRE_TOKEN_POPUP; //"Azure token response is empty from acquireTokenPopup method";
                       this.redirectToClientAppLoginWhenErrorOccured(errorReason);
                     }
                     //this.redirectToClientApplication();
                     
                     
                 }
                 ,
                 error => {
                   
                     let errorDesc=error;
                     this.displayActualErrorInConsole(errorDesc);
                     let errorReason= ErrorReason.ACQUIRE_TOKEN_POPUP_FAILURE;
                     this.redirectToClientAppLoginWhenErrorOccured(errorReason);
                   
                 },
                 
   
                 );
                 
                  
               }
                 
                 );
   
           } */

        },
      );

  }

  //acquire token token siliently when any error occured during login popup  account selection/ for any idle time scenario
  acquireTokenSilentImpl(request: any) {
    console.log("acquireTokenSilentImpl");
    this.LogError("Log.acquireTokenSilentImpl.Begin", "User Account: " + this.currentLoggedInUserEmail + "Request: " + this.convertObjToJsonString(request) , this.clientIdFromQueryString);
    this.authService.acquireTokenSilent(request)
      .subscribe((result: AuthenticationResult) => {
        console.log(result);
        const payload = result as AuthenticationResult;
        const loginAccount = payload.account;
        this.currentLoggedInUserEmail = loginAccount?.username;
        this.LogError("Log.acquireTokenSilent.AuthenticationResult", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);
        this.authService.instance.setActiveAccount(payload.account);

        let azureTokenRespObj = this.getAzureTokenResponseObjectForAquireTokenSilent(payload);//this.getAzureTokenResponseObject(payload);
        let azuretokenresp = this.getAzureTokenJsonResponseAsString(azureTokenRespObj);
        //this.azureTokenResponseGv=azuretokenresp;
        if (azuretokenresp != null && azuretokenresp != "")
          this.redirectToClientApplication(azuretokenresp);
        else {
          let errorReason = ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_ACQUIRE_TOKEN_SILENT; //"Azure token response is empty for acquireTokenSilent Method";
          this.redirectToClientAppLoginWhenErrorOccured(errorReason);
        }


      }
        ,
        error => {
          console.log("error at acquireTokenSilentImpl method call");
          this.LogError("Log.acquireTokenSilentImpl.Error", "User Account: " + this.currentLoggedInUserEmail + "Error:" + error, this.clientIdFromQueryString);
          let errorDesc = error;
          this.displayActualErrorInConsole(errorDesc, "acquireTokenSilentImpl.Error");
          //AcquireTokenSilent Failure, send an interactive request.
          this.LogError("Log.acquireTokenPopup.Begin", "User Account: " + this.currentLoggedInUserEmail , this.clientIdFromQueryString);
          this.authService.acquireTokenPopup(request)
            .subscribe((result: AuthenticationResult) => {
              console.log(result);
              const payload = result as AuthenticationResult;
              const loginAccount = payload.account;
              this.currentLoggedInUserEmail = loginAccount?.username;
              this.LogError("Log.acquireTokenPopup.AuthenticationResult", "User Account:" + loginAccount?.username, this.clientIdFromQueryString);

              this.authService.instance.setActiveAccount(payload.account);

              let azureTokenRespObj = this.getAzureTokenResponseObjectForAquireTokenSilent(payload);//this.getAzureTokenResponseObject(payload);
              let azuretokenresp = this.getAzureTokenJsonResponseAsString(azureTokenRespObj);
              //this.azureTokenResponseGv=azuretokenresp;
              if (azuretokenresp != null && azuretokenresp != "")
                this.redirectToClientApplication(azuretokenresp);
              else {
                let errorReason = ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_ACQUIRE_TOKEN_POPUP; //"Azure token response is empty from acquireTokenPopup method";
                this.LogError("Log.acquireTokenPopup.AuthenticationResult", "User Account: " + loginAccount?.username+ " Error:"+errorReason, this.clientIdFromQueryString);
                this.redirectToClientAppLoginWhenErrorOccured(errorReason);
              }
              //this.redirectToClientApplication();
            }
              ,
              error => {
                console.log("error at acquireTokenPopup method call");
                let errorDesc = error;
                this.LogError("Log.acquireTokenPopup.AuthenticationResult", "User Account: " + this.currentLoggedInUserEmail+ " Error:"+errorDesc, this.clientIdFromQueryString);
                this.displayActualErrorInConsole(errorDesc, "acquireTokenSilentImpl.acquireTokenPopup.Error");
                let errorReason = ErrorReason.ACQUIRE_TOKEN_POPUP_FAILURE;
                this.redirectToClientAppLoginWhenErrorOccured(errorReason);

              },
            );
        }
      );
  }

  /* promptForPasswordForUnAuthroizedRequest()
  {
    this.hideSSOButtons();
          console.log("already logged in, but unauthorized, autologin");
          let scopeId=environment.scopeId
            
            var request = {
              //scopes: ['user.read'] //["Mail.Read"]
              //scopes: ["api://8f491afb-add0-4cd4-82a5-f9e477d6a057/.default"]
              scopes: ["api://"+scopeId+"/.default"],
              //loginHint:'',
              prompt:'select_account'
          };
          this.authService.loginPopup(request)
                                  .subscribe((result: AuthenticationResult) => {
                  //alert('acquire token silent');
                  //alert(result.accessToken);

                  console.log(result);
                  const payload = result as AuthenticationResult;
                  
                  this.authService.instance.setActiveAccount(payload.account);
                  
                  let azureTokenRespObj= this.getAzureTokenResponseObjectForAquireTokenSilent(payload);//this.getAzureTokenResponseObject(payload);
                  let azuretokenresp= this.getAzureTokenJsonResponse(azureTokenRespObj);
                  //this.azureTokenResponseGv=azuretokenresp;
                  if(azuretokenresp!=null && azuretokenresp!="")
                      this.redirectToClientApplication(azuretokenresp);
                  else
                  {
                    let errorReason= ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_ACQUIRE_TOKEN_POPUP;//"Azure token response is empty from acquireTokenPopup method";
                    this.redirectToClientAppLoginWhenErrorOccured(errorReason);
                  }
                  //this.redirectToClientApplication();
                  
                  
              }
              ,
              
              error => {
               
                //alert(error);
                var errorDesc=error.toString();
                let errorReason=''
                //alert(typeof errorDesc);
                if(typeof errorDesc == "string" && errorDesc.indexOf(ErrorReason.USER_CANCELLED) > -1)
                {
                  //errorReason= ErrorReason.USER_CANCELLED_FROM_UNAUTHORIZED_AT_LOGIN_POPUP;
                  //this.redirectToClientAppLoginWhenErrorOccured(errorReason);
                  this.acquireTokenSilientImpl(request);
                }
                else
                {
                  this.displayActualErrorInConsole(errorDesc);
                  errorReason=ErrorReason.UNKNOWN_ERROR_OCCURED;
                  this.redirectToClientAppLoginWhenErrorOccured(errorReason);
                }
              },
              );

              
  } */

  getAzureTokenResponseObject(payload: AuthenticationResult) {
    let refreshtokenObj = <RefreshTokenResponseModel>this.auzureTokenRespService.getRefreshTokenJsonFromLocalStorage();
    this.currentLoggedInUserEmail = payload.account?.username;
    this.LogError("Log.getAzureTokenResponseObject.refreshtokenObj", "User Account : " + payload.account?.username! + " " + this.convertObjToJsonString(refreshtokenObj), this.clientIdFromQueryString);
    let azureTokenRespObj = new AzureTokenResponseModel();
    azureTokenRespObj.accesstoken = payload.accessToken;//payload.idToken;
    azureTokenRespObj.useremail = payload.account?.username!;
    azureTokenRespObj.username = payload.account?.name!;
    azureTokenRespObj.idtoken = payload.idToken;
    azureTokenRespObj.refreshtoken = refreshtokenObj.secret;
    azureTokenRespObj.ssotype = environment.azureADProvider;
    this.LogError("Log.getAzureTokenResponseObject.azureTokenRespObj", "User Account : " + azureTokenRespObj.useremail + " " + this.convertObjToJsonString(azureTokenRespObj), this.clientIdFromQueryString);
    return azureTokenRespObj;
  }

  getAzureTokenResponseObjectForAquireTokenSilent(payload: AuthenticationResult) {
    /* let refreshtokenObj=<RefreshTokenResponseModel>this.auzureTokenRespService.getRefreshTokenJsonFromLocalStorage()
    let azureTokenRespObj=new AzureTokenResponseModel();
    azureTokenRespObj.accesstoken= payload.accessToken;
    azureTokenRespObj.useremail=payload.account?.username!;
    azureTokenRespObj.username=payload.account?.name!;
    azureTokenRespObj.idtoken=payload.idToken;
    azureTokenRespObj.refreshtoken=refreshtokenObj.secret; 
    azureTokenRespObj.ssotype=environment.azureADProvider;
    return azureTokenRespObj; */
    return this.getAzureTokenResponseObject(payload);
  }

  /* getAzureTokenResponseObjectForAlreadySingleSingON()
  {
          let refreshtokenObj=<RefreshTokenResponseModel>this.auzureTokenRespService.getRefreshTokenJsonFromLocalStorage()
          let idTokenObj=<AzureIdTokenResponseModel>this.auzureTokenRespService.getIdTokenJsonFromLocalStorage();
          let accessTokenObj=<AzureAccessTokenResponseModel>this.auzureTokenRespService.getAccessTokenJsonFromLocalStorage();
          let idTokenClaimsObj=<AzureIdTokenClaimsResponseModel>this.auzureTokenRespService.getIdTokenCliamsJsonFromLocalStorage();
          let azureTokenRespObj=new AzureTokenResponseModel();
          azureTokenRespObj.accesstoken= accessTokenObj.secret; //idTokenObj.secret;//accessTokenObj.secret;
          azureTokenRespObj.useremail=idTokenClaimsObj.username;
          azureTokenRespObj.username=idTokenClaimsObj.name;
          azureTokenRespObj.idtoken=idTokenObj.secret;
          azureTokenRespObj.refreshtoken=refreshtokenObj.secret; 
          azureTokenRespObj.ssotype=environment.azureADProvider;
          return azureTokenRespObj;
  } */

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    if (this.loginDisplay)
      $('#btnLogout').css('display', 'block');

  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);

      this.LogError("Log.checkAndSetActiveAccount", "Multiple accounts, setting active account to: " + accounts[0].username + " AuthorityType: " + accounts[0].authorityType , this.clientIdFromQueryString);
    }
  }

  //If it is coming back after a failure we can prompt for username/password
  async loginPopupPromptForUserNamAndPwd() {
    
    if(this.loginFailureCounter<2)
    {
          this.loginFailureCounter= this.loginFailureCounter+1;
          let scopeId = environment.scopeId;
        var request = {
          scopes: ["api://" + scopeId + "/.default"],
          prompt: 'login'
        };

        if (this.msalGuardConfig.authRequest) {
          try {
                const response: AuthenticationResult = await firstValueFrom(
                this.authService.loginPopup(request)
              );
              const loginAccount = response.account;
              this.currentLoggedInUserEmail = loginAccount?.username;
              this.LogError("Log.loginPopupPromptForUserNamAndPwd.msalGuardConfig.authRequest", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);
              this.authService.instance.setActiveAccount(response.account); 
          } catch (error: any) {
              const errorDesc = error?.message || error.toString();
              this.displayActualErrorInConsole(errorDesc, "loginPopupForUserNamAndPwd.Request.Error");
          }
            
          
        } else {
              try {
                const response: AuthenticationResult = await firstValueFrom(
                this.authService.loginPopup(request)
              );
              const loginAccount = response.account;
              this.currentLoggedInUserEmail = loginAccount?.username;
              this.LogError("Log.loginPopupPromptForUserNamAndPwd.msalGuardConfig.authRequest.Else", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);
              this.authService.instance.setActiveAccount(response.account); 
            } catch (error: any) {
                const errorDesc = error?.message || error.toString();
                this.displayActualErrorInConsole(errorDesc, "loginPopupForUserNamAndPwd.msalGuardConfig.authRequest.Else.Error");
                let errorReason = ErrorReason.LOGIN_POPUP_FAILURE;
                this.redirectToClientAppLoginWhenErrorOccured(errorReason);
            }
          

        }
    }
    else
    {
      this.LogError("Log.loginPopupPromptForUserNamAndPwd.Else", "User Account: " + this.currentLoggedInUserEmail +"Login Attempts exceeded more than 1 time, Login attempts tried: "+ this.loginFailureCounter, this.clientIdFromQueryString);
      let errorReason = ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_FIRST_TIME_LOGIN;
      this.redirectToClientAppLoginWhenErrorOccured(errorReason);
    }
    

  }

  handleLoginResponse(response:AuthenticationResult)
  {
      const loginAccount = response.account;
      this.currentLoggedInUserEmail = loginAccount?.username;
      this.LogError("Log.handleLoginResponse", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);
      this.authService.instance.setActiveAccount(response.account); 

      let azureTokenRespObj = this.getAzureTokenResponseObject(response);
      let azuretokenresp = this.getAzureTokenJsonResponseAsString(azureTokenRespObj);
      if (azuretokenresp != null && azuretokenresp != undefined && azuretokenresp.length > 0) {
        localStorage.setItem("azureTokenRespLocalStorage", azuretokenresp);
        this.LogError("Log.handleLoginResponse.LOGIN_SUCCESS", "RedirectToClient. User Account: " + loginAccount?.username, this.clientIdFromQueryString);
        this.redirectToClientApplication(azuretokenresp); // This posts the message.
      }
      else //LOGIN_SUCCESS fallback scenario
      {
        let errorReason = ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_FIRST_TIME_LOGIN; //"Azure token response is empty for First time azure login";
        this.LogError("Log.handleLoginResponse.LOGIN_SUCCESS.Else", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);          
        this.redirectToClientAppLoginWhenErrorOccured(errorReason);
        //this.loginPopupPromptForUserNamAndPwd();
        //this.invokeAcquireTokenSilent();
      }
  }
  async loginPopup(): Promise<AuthenticationResult | null> { 
    this.LogError("Log.loginPopup.Start", "loginInProgress flag value:"+ this.loginInProgress , this.clientIdFromQueryString);
    console.log("loginInProgress flag value:"+ this.loginInProgress);
    if (this.loginInProgress) return null; // ignore if already in progress
    this.loginInProgress = true;
    //clearing msal local storage and msal session storage in the begining of this method.
    this.commonUtilSvc.clearMSALLocalStorage();
    this.commonUtilSvc.clearMSALSessionStorage();

    let scopeId = environment.scopeId;
    var request = {
      scopes: ["api://" + scopeId + "/.default"],
      prompt: 'select_account'
    };
    var requestWithPwd = {
      scopes: ["api://" + scopeId + "/.default"],
      prompt: 'login'
    };
    const maxAzureLoginRetries : number= environment.maxAzureLoginRetries; //3 configured in environment.ts file
    const maxAzureLoginDelay : number = environment.maxAzureLoginDelay;
    const maxAzureLoginWithSelectRetries : number = environment.maxAzureLoginWithSelectRetries;
    sessionStorage.removeItem('msal.interaction.status'); // Clears the stale interaction status if any before starting
    this.clearMsalKeys(-1);
    await delayLoop(500); 
    if (this.msalGuardConfig.authRequest) {
      for (let i = 0; i < maxAzureLoginRetries; i++) 
      {  
        
          try { 
                this.LogError("Log.loginPopup.For.Try","User Account: " + this.currentLoggedInUserEmail + " RetryCount: "+ i.toString(),this.clientIdFromQueryString);
                const currentRequest = (i < maxAzureLoginWithSelectRetries) ? request : requestWithPwd;
                const response: AuthenticationResult = await firstValueFrom(
                    this.authService.loginPopup(currentRequest)
                );
                this.loginInProgress = false;
                this.LogError("Log.loginPopup.For.Try", "User Account: " + this.currentLoggedInUserEmail + " successful login in RetryCount: " + i.toString(), this.clientIdFromQueryString);
                return response; // Return the authentication result
          } catch (error: any) {
              this.loginInProgress = false;
              const errorDesc = error?.message || error.toString();
              this.LogError("Log.loginPopup.For.catch","User Account: " + this.currentLoggedInUserEmail + " RetryCount: "+ i.toString() + " Error:"+ errorDesc,this.clientIdFromQueryString);
              this.displayActualErrorInConsole(errorDesc, "loginPopup.For.catch");
             /*  if (errorDesc?.message.includes('50140')
                  || errorDesc?.message.includes('interaction_in_progress')
                  || errorDesc?.message.includes('popup_window_error')
                  || errorDesc?.message.includes('network_error')
                  || errorDesc?.message.includes('server_error')
                ) {
                console.warn(errorDesc+ 'Retrying login...');
                this.LogError("Log.loginPopup.LOGIN_FAILURE.If", "User Account: " + this.currentLoggedInUserEmail + " " + errorDesc.error?.message, this.clientIdFromQueryString);
                //this.loginPopupPromptForUserNamAndPwd();
              }*/

              // Handle popup blocked
              /*if (errorDesc?.toLowerCase().includes('popups are blocked')) 
              {
                this.redirectToClientAppLoginWhenErrorOccured(ErrorReason.POPUP_BLOCKED_IN_BROWSER);
                break;
              }*/
             
              // Last retry
              if (i == maxAzureLoginRetries - 1) {
                this.redirectToClientAppLoginWhenErrorOccured(ErrorReason.GENERIC_LOGIN_FAILURE);
                break;
              } 
              
              if (i === 0) { // After first failure
                console.log('Clearing MSAL storage cache after first failure...');
                this.clearMsalKeys(i);
                this.LogError("Log.loginPopup.For.catch.clearMsalKeys", "User Account: "+ this.currentLoggedInUserEmail + " RetryCount: " + i.toString() , this.clientIdFromQueryString);
                 await delayLoop(1000); 
              }
              else
              {
                 // Handle stale interaction
                if (errorDesc.includes('interaction_in_progress')) {
                  console.warn('Detected interaction_in_progress, clearing stale session...');
                  sessionStorage.removeItem('msal.interaction.status');
                  this.LogError("Log.loginPopup.For.catch.clear.interaction.status", "User Account: "+ this.currentLoggedInUserEmail + " RetryCount: " + i.toString() , this.clientIdFromQueryString);
                   await delayLoop(1000); // add Small delay
                }
              }
          }
          
          await delayLoop(maxAzureLoginDelay);
        }
        

      /* this.authService.loginPopup(request)
        .subscribe((response: AuthenticationResult) => {
          const loginAccount = response.account;
          this.currentLoggedInUserEmail = loginAccount?.username;
          this.LogError("Log.msalGuardConfig.authRequest.loginPopup", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);
          this.authService.instance.setActiveAccount(response.account);
        },
          error => {

            var errorDesc = error.toString();
            let errorReason = '';
            if (error.errorCode === '50140' || error.message.includes('50140')) {
              console.warn('KMSI interrupt (50140). Falling back to redirect...');
              this.LogError("Log.msalGuardConfig.authRequest.loginPopup.Error", "User Account: " + this.currentLoggedInUserEmail + "Error: " + error.message + " Error code:" + error.errorCode, this.clientIdFromQueryString);
              // Fallback to redirect
              this.authService.loginRedirect({
                scopes: ["api://" + scopeId + "/.default"],
                prompt: 'select_account',
              });
            }
            this.displayActualErrorInConsole(errorDesc, "loginPopup.Request.Error");
            if (typeof errorDesc == "string" && errorDesc.indexOf(ErrorReason.USER_CANCELLED) > -1) {
              errorReason = ErrorReason.USER_CANCELLED;
              console.warn("User cancelled the authentication flow.");
            }
            else {
              errorReason = ErrorReason.MSAL_GUARD_CONFIG_AUTH_REQUEST_LOGIN_POPUP_FAILURE;
              console.error("An error occurred during loginPopup: ", errorDesc);
            }
            //this.redirectToClientAppLoginWhenErrorOccured(errorReason);
          }
        ); */
    } else {
          try {
            const response: AuthenticationResult = await firstValueFrom(
              this.authService.loginPopup(request)
            );
            const loginAccount = response.account;
            this.currentLoggedInUserEmail = loginAccount?.username;
            this.LogError("Log.loginPopup.authRequest.Else", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);
            this.authService.instance.setActiveAccount(response.account); 
            /* this.authService.loginPopup(request)
                .subscribe((response: AuthenticationResult) => {
                  const loginAccount = response.account;
                  this.currentLoggedInUserEmail = loginAccount?.username;
                  this.LogError("Log.loginPopup.authRequest.Else", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);
                  this.authService.instance.setActiveAccount(response.account); 
                }); */
         
        } catch (error: any) {
            const errorDesc = error?.message || error.toString();
            this.displayActualErrorInConsole(errorDesc, "loginPopup.authRequest.Else.catch");
            let errorReason = ErrorReason.LOGIN_POPUP_FAILURE;
            this.redirectToClientAppLoginWhenErrorOccured(errorReason);
        }
       /* this.authService.loginPopup()
        .subscribe((response: AuthenticationResult) => {
          const loginAccount = response.account;
          this.currentLoggedInUserEmail = loginAccount?.username;
          this.LogError("Log.msalGuardConfig.authRequest.Else", "User Account: " + loginAccount?.username, this.clientIdFromQueryString);
          this.authService.instance.setActiveAccount(response.account);
        },
          error => {
            let errorDesc = error;
            this.displayActualErrorInConsole(errorDesc, "loginPopup.msalGuardConfig.authRequest.Else.Error");
            let errorReason = ErrorReason.LOGIN_POPUP_FAILURE;
            this.redirectToClientAppLoginWhenErrorOccured(errorReason);

          },
        ); */

    }

    return null; //fallback
  }

  clearMsalKeys(i : number) {
    const storage = sessionStorage;
  
    const msalKeysToClear = [
      'msal.interaction.status', // Remove the current interaction status
      'msal.active_account',     // Remove active account metadata
      'msal.sso_accounts'        // Clear previously signed-in accounts
    ];

    const clearedKeys: string[] = [];
  
    msalKeysToClear.forEach(key => {
      if (storage.getItem(key)) {
        storage.removeItem(key);
        clearedKeys.push(key);
      }
    });
  
    if (clearedKeys.length > 0) {
      console.log("cleared stale MSAL keys: "+ clearedKeys.join(', '));
      this.LogError("Log.loginPopup.clearMsalKeys", "User Account: "+ this.currentLoggedInUserEmail + " RetryCount: " + i.toString() + " clearedKeys: " + clearedKeys.join(', '), this.clientIdFromQueryString);
    } else {
      console.log("No stale MSAL keys found to clear.");
    }
  }

  displayPnlComingSoon() {
    $('#pnlComingSoon').css("display", "block");
    setTimeout(function () {
      $('#pnlComingSoon').css("display", "none");
    }, 2000);

  }

  hidePnlComingSoon() {
    $('#pnlComingSoon').css("display", "none");
  }
  
  redirectToClientAppLoginWhenErrorOccured(errorDesc: string) {
    console.log("redirectToClientAppLoginWhenErrorOccured error is  " + errorDesc);
    this.LogError("Log.redirectToClientAppLoginWhenErrorOccured", "User Account: " + this.currentLoggedInUserEmail + " error is :" + errorDesc, this.clientIdFromQueryString);
    this.clearLocalStorage();
    this.LogError("Log.redirectToClientAppLoginWhenErrorOccured.Request", "User Account: " + this.currentLoggedInUserEmail + " Client App Login Url: " + this.clientAppLoginUrl + "?errorReason=" + errorDesc, this.clientIdFromQueryString);
    let loginUrlFragment = this.getLoginUrlFragment();
    if (loginUrlFragment.length > 0) {
      let loginUrl = this.clientAppLoginUrl.indexOf('?') > 0 ? this.clientAppLoginUrl + '&' + loginUrlFragment + "&errorReason=" + errorDesc
        : this.clientAppLoginUrl + "?" + loginUrlFragment + "&errorReason=" + errorDesc;
      this.LogError("Log.redirectToClientAppLoginWhenErrorOccured.ModifiedLoginUrl", "User Account: " + this.currentLoggedInUserEmail + " Client App Login Url: " + loginUrl, this.clientIdFromQueryString);
      window.location.href = loginUrl;
    }
    else
      window.location.href = this.clientAppLoginUrl + "?errorReason=" + errorDesc;
  }

  displayActualErrorInConsole(errorDesc: string, errorOrigin: string) {
    console.log(errorOrigin+ ":" + ' Actual error is:' + errorDesc);
    //console.log(errorDesc);
    this.LogError("Log.displayActualErrorInConsole." + errorOrigin, "User Account: " + this.currentLoggedInUserEmail + " " + errorDesc, this.clientIdFromQueryString);
  }

  logout(popup?: boolean) {
    let returnUrl = window.location.href;
    let clientId = this.getRpostClientId();

    let callbackUrl = this.getCallBackUrl();

    if (popup) {
      this.authService.logoutPopup({

        mainWindowRedirectUri: returnUrl

      });
    } else {
      this.authService.logoutRedirect();
    }
  }
  /* callRCAPExternalTokenAPI(providerAccessToken:string)
  {
    
    var externalTokenModelObj=new ExternalTokenModel();
    var clientId=localStorage.getItem("clienIdLS")!;
    
    if(clientId==null)
    {
      alert(clientId);
      return;
    }
    externalTokenModelObj.Client_Id=clientId;
    externalTokenModelObj.provider='AzureAD'; //To DO: Need to Remove hardcoded value
    externalTokenModelObj.provider_access_token=providerAccessToken;

    this.rpostAuthService.getExternalTokenAPIResponseToken(externalTokenModelObj)
    .subscribe(async resp => {
      
        const response = resp as IExternalTokenResponseDetails;
        localStorage.setItem("extTokenAPIResponse_"+clientId,resp.toString()); 
        let callbackUrl= this.getCallBackUrl();//localStorage.getItem("callbackUrl_"+clientId)!;
        this.postLocalStorageData(callbackUrl, 'trackingportal');
        window.location.href = callbackUrl;
         
  });
  } */

  generateDataShareIframeHtmlElement(callbackUrl: string, rpostClientId: string) {
    //removeIframeElement(rpostClientId);
    const iframe = document.createElement('IFRAME');
    iframe.id = 'receiverSOS1_' + rpostClientId;
    //iframe.id = 'receiverIframe';
    iframe.style.display = "none";
    iframe.style.width = "1px";
    //iframe.sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin"
    (<HTMLIFrameElement>iframe).src = callbackUrl;
    document.body.appendChild(iframe);

  }

  postLocalStorageData(linkURL: any, portal: any) {

    this.dataShareService.postCrossDomainMessage(linkURL, portal);
  }

  isUserAlreadyLoggedin() {
    let isLoggedIn = this.authService.instance.getAllAccounts().length > 0;
    if (isLoggedIn) {
      let accountInfo = this.authService.instance.getAllAccounts();
      for (let item of accountInfo) {

        this.LogError("Log.isUserAlreadyLoggedin", "UserName: " + item?.username, this.clientIdFromQueryString);
      }

    }
    else {
      this.LogError("Log.isUserAlreadyLoggedin", "First time login, no user account already logged in", this.clientIdFromQueryString);
    }
    /* if(isLoggedIn)
      this.setAzureTokenResponseFromCookie(); */
    return isLoggedIn;
  }

  /*  setAzureTokenResponseIntoLocalStorage(clientId:string,azureTokenResp:string)
   {
     localStorage.setItem("azuretokenresp_"+clientId,azureTokenResp);
   } */
  /* setAzureTokenResponseFromCookie()
  {
    let clientId=this.getRpostClientId();
    let azureTokenRespFromCookie=this.getCookie(clientId);
    let azureTokenResponseFromLocalStorage=localStorage.getItem("azuretokenresp_"+ this.getAzureClientId());
    if((azureTokenResponseFromLocalStorage==null
      || azureTokenResponseFromLocalStorage ==undefined)
      &&(azureTokenRespFromCookie!=null && azureTokenRespFromCookie!=undefined)
      )
      {
       
        //localStorage.setItem("azuretokenresp_"+ clientId,azureTokenRespFromCookie); 
        this.setAzureTokenResponseIntoLocalStorage(clientId,azureTokenRespFromCookie);
      }
  }
 */
  getRpostClientId() {

    return this.clientIdFromQueryString;
  }

  getCallBackUrl() {


    return this.callBackUrlFromQueryString;
  }

  getAzureClientId() {
    return environment.azureSSOClientId;
  }
  getAzureTokenJsonResponseAsString(azureTokenRespObj: AzureTokenResponseModel) {
    let response: string = "";
    response = JSON.stringify(azureTokenRespObj);
    let userEmail = azureTokenRespObj?.useremail;
    this.currentLoggedInUserEmail = userEmail;
    this.LogError("Log.getAzureTokenJsonResponseAsString.Response", "User Account : " + userEmail + " " + response, this.clientIdFromQueryString);

    return response;
  }
  clearLocalStorageTokenResponse() {
    let clientId = this.getRpostClientId();

    localStorage.removeItem("azuretokenresp_" + this.getAzureClientId());
  }

  redirectToClientApplication(azureTokenResponse: string) {

    this.onLoad(azureTokenResponse);
    //this.dataShareService.postCrossDomainMessage("test");
  }


  onLoad(azureTokenResponse: string) {
    let clientId = this.getRpostClientId();
    let callbackUrl = this.getCallBackUrl();
    //alert(callbackUrl);
    let azuretokenResp = azureTokenResponse;

    const date = new Date();

    //POST MESSAGE
    console.log('is window:load');
    var iframe = document.getElementById("receiverSOS1_" + clientId);
    //const iframe = document.getElementById("receiverIframe");
    console.log(iframe);
    //alert(iframe)
    //if (iframe == null) { return; }
    if (iframe == null) {
      this.generateDataShareIframeHtmlElement(callbackUrl, clientId);
      iframe = document.getElementById("receiverSOS1_" + clientId);
    }
    const iWindow = (iframe as HTMLIFrameElement).contentWindow!;
    let msgToPost = JSON.stringify(azuretokenResp);
    let userEmail = this.currentLoggedInUserEmail;
    this.LogError("Log.onLoad", "User Account : " + userEmail + " CallbackUrl is :" + callbackUrl, clientId);
    if (msgToPost != null && msgToPost != '') {
      console.log('Azure token response exists');
      this.LogError("Log.onLoad", "User Account : " + userEmail + " Azure token response exists and msgToPost is :" + msgToPost, clientId);
    }
    else {
      console.log('Azure token response not exists');
      this.LogError("Log.onLoad", "User Account : " + userEmail + " Azure token response does not exists." + msgToPost, clientId);
    }


    //let domainUrl=getDomainUrl(callbackUrl);


    this.displaySpinner();
    /* iWindow.addEventListener("load", function() {
      console.log("Finish");
      this.alert('iframe loaded');
     });
     */
     try {
        if (iframe != null && msgToPost != null && msgToPost != '') {
          this.clearLocalStorage();
          iWindow.postMessage(msgToPost, '*');
          setTimeout(function () {
            //iWindow.postMessage(msgToPost, callbackUrl);
            //alert(callbackUrl);
            console.log('callbackUr is ' + callbackUrl);
            window.location.href = callbackUrl;
          //}, 1000); 
          }, 4000); // increased
        }
        else {
          let errorDesc = '';
          if (iframe == null) {
            errorDesc = ErrorReason.COULD_NOT_ABLE_TO_SEND_MESSAGE;
            this.LogError("Log.onLoad.Post.SendMessageFail", "User Account : " + userEmail +  " Error: COULD_NOT_ABLE_TO_SEND_MESSAGE",this.clientIdFromQueryString);
            this.redirectToClientAppLoginWhenErrorOccured(errorDesc);
          }
          else if (msgToPost == null || msgToPost == '') {
            errorDesc = ErrorReason.AZURE_TOKEN_EMPTY_RESPONSE_BEFORE_SENDING_MESSAGE;
            this.LogError("Log.onLoad.Post.EmptyMsgToPost", "User Account : " + userEmail +  " Error: msgToPost is empty",this.clientIdFromQueryString);
            this.redirectToClientAppLoginWhenErrorOccured(errorDesc);
          }

        }
    } catch (error: any) {
      const errorCatchDesc = error?.message || error.toString();
      this.LogError("Log.onLoad.Post.Error", "User Account : " + userEmail +  " Error:"+ errorCatchDesc,this.clientIdFromQueryString);
      this.displayActualErrorInConsole(errorCatchDesc, "Log.onLoad.Post.Error");
      const errorReturnDesc = ErrorReason.UNEXPECTED_ERROR_DURING_TOKEN_POST_MESSAGE;
      this.redirectToClientAppLoginWhenErrorOccured(errorReturnDesc);
    }
  }

  clearLocalStorage() {
    localStorage.clear();
  }

  setCookie(name: string, value: string, expireDays: number, path: string = '') {
    let d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }

  LogError(type: string, logText: string, clientId: string) {
   
    this.commonUtilSvc.LogError(type, logText, clientId);
      /* .subscribe({
        next: (resp) => {
          console.log(resp);

        }
        ,
        error: (e) => console.error(e) */
     // });
  }


  private getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

  private deleteCookie(name: string) {
    this.setCookie(name, '', -1);
  }


}

//Refernces - testPauseLoop
//https://medium.com/@chrisjr06/why-and-how-to-avoid-await-in-a-for-loop-32b86722171
function delayLoop(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}
 

function getDomainUrl(callbackUrl: any) {
  var str = callbackUrl,
    delimiter = '/',
    start = 3,
    tokens = str.split(delimiter).slice(start),
    result = tokens.join(delimiter);

  console.log(result)

  // To get the substring BEFORE the nth occurence
  var tokens2 = str.split(delimiter).slice(0, start),
    result2 = tokens2.join(delimiter); // this

  console.log(result2)
  return result2
}

/* function getRefreshTokenJsonFromLocalStorage() {

  var values = [],
      keys = Object.keys(localStorage),
      i = keys.length;
  var localStorageItem=''
  while ( i-- ) {
     if(keys[i].indexOf('login.windows.net-refreshtoken')!=-1)
     {
        localStorageItem=localStorage.getItem(keys[i])!;
        break;
     }
     
  }
  let jsonObj: any = JSON.parse(localStorageItem); 
  return jsonObj;
} */

function removeIframeElement(rpostClientId: string) {
  document.getElementById('receiverSOS1_' + rpostClientId)?.remove();
}

function detectPopupBlocker() {

  var isPopupblocker = false;
  var windowUrl = 'about:blank';
  var windowId = 'TestPopup_' + new Date().getTime();
  var windowFeatures = 'left=0%,top=0%,width=0.1%,height=0.1%';
  var windowRef = window.open(windowUrl, windowId, windowFeatures);

  if (!windowRef) {
    //alert('A popup blocker was detected. Please turn it off to use this application.');
    //return false;
    $('#pnlPopupblockerMsg').css("display", "block");
    isPopupblocker = true;
  }
  else {
    // No popup blocker was detected...
    windowRef.close();
    isPopupblocker = false;
    $('#pnlPopupblockerMsg').css("display", "none");
    //document.getElementById('pageContent').style.display = 'block';
  }

  return isPopupblocker;
}

function postMessageToClientAppIfUserAlreadyLoggedin(clientId: string, callbackUrl: string, azuretokenResp: string) {
  alert('postMessageToClientApp');
  //const iframeWin = document.getElementById('h5-iframe').contentWindow;
  const iframe = document.getElementById("receiverSOS1_" + clientId);
  //const iframe = document.getElementById("receiverIframe");
  console.log(iframe);
  //let azuretokenResp= this.azureTokenResponseGv;
  var msgToPost = JSON.stringify(azuretokenResp);
  //alert(iframe)
  if (iframe == null) { return; }
  const iWindow = (iframe as HTMLIFrameElement).contentWindow!;
  window.addEventListener(
    'message',
    (e) => {
      const { data } = e;
      console.log('receive page load', data);
      if (data.pageLoaded) {
        /* iframeWin.postMessage("hello", '*'); */
        // setTimeout(function () {
        iWindow.postMessage("rrrrr", '*');

        /* if(callbackUrl.indexOf('?IsAzureSSO=Y')==-1)
            callbackUrl=callbackUrl+"?IsAzureSSO=Y"; */
        //alert('callbackUrl'+callbackUrl);
        window.location.href = callbackUrl;
        //}, 1000);

      }
      else {
        alert('iframe page is not loaded');
        setTimeout(function () {
          iWindow.postMessage('not', '*');

          /* if(callbackUrl.indexOf('?IsAzureSSO=Y')==-1)
              callbackUrl=callbackUrl+"?IsAzureSSO=Y"; */
          //alert('callbackUrl'+callbackUrl);
          window.location.href = callbackUrl;
        }, 1000);
      }
    },
    false,
  );
}

function displaySpinner() {
  throw new Error('Function not implemented.');
}

function handleGoogleToken(response: any) {
  console.log(response);
  alert(response);
  //this.getGoogleTokenResponseAndRedirectToClientApplication();
}



function handleCredentialResponse() {
  // decodeJwtResponse() is a custom function defined by you
  // to decode the credential response.
  //const responsePayload = decodeJwtResponse(response.credential);

  /* console.log("ID: " + responsePayload.sub);
  console.log('Full Name: ' + responsePayload.name);
  console.log('Given Name: ' + responsePayload.given_name);
  console.log('Family Name: ' + responsePayload.family_name);
  console.log("Image URL: " + responsePayload.picture);
  console.log("Email: " + responsePayload.email); */
  alert('google login');
}


// Serialize an Error object including stack trace
function serializeError(error: any): any {
  if (!error) return null;

  const plainError: any = {};
  Object.getOwnPropertyNames(error).forEach(key => {
    plainError[key] = error[key];
  });

  // Optionally, serialize nested cause if present
  if (error.cause) {
    plainError.cause = serializeError(error.cause);
  }

  return plainError;
}

// Serialize the EventMessage to JSON string including error stack
function eventMessageToJsonString(event: any): string {
  if (!event) return '{}';

  // Copy all own properties of the event (including non-enumerable if needed)
  const plainEvent: any = {};
  Object.getOwnPropertyNames(event).forEach(key => {
    plainEvent[key] = event[key];
  });

  // Serialize error if present
  if (event.error) {
    plainEvent.error = serializeError(event.error);
  }

  return JSON.stringify(plainEvent, null, 2);
}



/* function trackGoogleLoginPopupClose()
{
  window.onload = function () {
    google.accounts.id.initialize({

      // Ref: https://developers.google.com/identity/gsi/web/reference/js-reference#IdConfiguration
    client_id: environment.googleSSOClientId,
    //callback: this.handleCredentialResponse.bind(this), // Whatever function you want to trigger...
    auto_select: false,
    ux_mode: 'popup',
    cancel_on_tap_outside: false
  });
    google.accounts.id.prompt((notification) => {
      if (notification.getDismissedReason()=='cancel_called') {
        // continue with another identity provider.
        alert('cancel');
      }
    });
  };
} */










